import { render, staticRenderFns } from "./WizStep.vue?vue&type=template&id=265179b2&scoped=true&"
import script from "./WizStep.vue?vue&type=script&lang=js&"
export * from "./WizStep.vue?vue&type=script&lang=js&"
import style0 from "./WizStep.vue?vue&type=style&index=0&id=265179b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265179b2",
  null
  
)

export default component.exports